import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as Events from "./events";
import TaskTracker from "./TaskTracker";
import Deferred from "./utils/Deferred";
import MessageQueue from "./utils/MessageQueue";
import { getNavigationTiming } from "./utils/observers";
export default class Telemetry {
  static setPage(pageName = 'PAGE_UNKNOWN') {
    // If we'd previously set a page and are changing it now,
    // it should be= a client side render
    if (Telemetry.activePageName && Telemetry.activePageName !== pageName) {
      Telemetry.isInitialRender = false;
      Telemetry.pageNavigationStartTime = performance.now();
      Telemetry.isPageReady.resolve();
    }

    Telemetry.activePageName = pageName;
  }

  static fireComponentBoundaryError(componentName, error) {
    Telemetry.messageQueue.emit({
      type: Events.LABEL_COMPONENT_ERROR_BOUNDARY,
      componentName,
      error
    });
    Telemetry.abortAllTasks(error);
  }

  static fireSearchTiming(duration) {
    Telemetry.messageQueue.emit({
      type: Events.LABEL_ALGOLIA_SEARCH_TIMING,
      duration
    });
  }

  static task(options) {
    const {
      successful,
      task,
      taskId,
      duration,
      cause
    } = options;
    Telemetry.messageQueue.emit({
      type: Events.LABEL_GENERIC_TASK,
      successful,
      task,
      taskId,
      duration,
      cause
    });
  }

  static createTask(taskName) {
    const createdTask = new TaskTracker(taskName);
    createdTask.addCompletionListener(args => {
      const {
        success,
        duration,
        cause,
        taskId,
        task: currentTask
      } = args;
      Telemetry.task({
        task: currentTask,
        taskId,
        cause,
        successful: success,
        duration
      });
    });
    Telemetry.registeredTasks.push(createdTask);
    return createdTask;
  }

  static abortAllTasks(error) {
    Telemetry.registeredTasks.forEach(task => task.failed(error));
  }

  static timeToFirstPaint(duration) {
    Telemetry.messageQueue.emit({
      type: Events.LABEL_TIME_TO_FIRST_CONTENTFUL_PAINT,
      duration
    });
  }

  static timeToFirstMeaningfulPaint(endTime) {
    Telemetry.messageQueue.emit({
      type: Events.LABEL_TIME_TO_FIRST_MEANINGFUL_PAINT,
      endTime
    });
  }

  static timeToLargestContentfulPaint(duration) {
    Telemetry.messageQueue.emit({
      type: Events.LABEL_TIME_TO_LARGEST_CONTENTFUL_PAINT,
      duration
    });
  }

  static firstInputDelay(duration) {
    Telemetry.messageQueue.emit({
      type: Events.LABEL_FIRST_INPUT_DELAY,
      duration
    });
  }

  static timeToFirstByte(duration) {
    Telemetry.messageQueue.emit({
      type: Events.LABEL_TIME_TO_FIRST_BYTE,
      duration
    });
  }

  static timeToInteractive(duration) {
    Telemetry.messageQueue.emit({
      type: Events.LABEL_TIME_TO_INTERACTIVE,
      duration
    });
  }

  static cumulativeLayoutShift(shift) {
    Telemetry.messageQueue.emit({
      type: Events.LABEL_CUMULATIVE_LAYOUT_SHIFT,
      shift
    });
  }

  static resourceDownloadTime(type, duration) {
    Telemetry.messageQueue.emit({
      type: Events.LABEL_RESOURCE_DOWNLOAD_TIME_SUM,
      duration,
      resourceType: type
    });
  }

}

_defineProperty(Telemetry, "messageQueue", new MessageQueue());

_defineProperty(Telemetry, "registeredTasks", []);

_defineProperty(Telemetry, "isInitialRender", true);

_defineProperty(Telemetry, "activePageName", null);

_defineProperty(Telemetry, "pageNavigationStartTime", getNavigationTiming().fetchStart);

_defineProperty(Telemetry, "isPageReady", new Deferred());